module.exports = __webpack_public_path__ + "static/media/filled-heart.6363d263.svg";